import React from 'react';
import { CalendarDays, RefreshCw, Building } from 'lucide-react';

export default function CalendarTab({
  cursorDate,
  setCursorDate,
  selectedCalendarYear,
  setSelectedCalendarYear,
  setSelectedDetailMonth,
  calendarViewMode,
  setCalendarViewMode,
  PROPRIEDADES,
  propertyRoomsMatrix,
  collapsedProperties,
  togglePropertyCollapse,
  parseDateAgnostic,
  obterStatusRealStay,
  focarInquilinoNaTimeline
}) {
  return (
    <div className="space-y-6 animate-fadeIn">
      {/* CABEÇALHO DO CALENDÁRIO UNIFICADO */}
      <div className="bg-white p-5 rounded-2xl shadow-sm border border-slate-200 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div className="space-y-1">
          <h2 className="text-xl font-extrabold text-slate-900 flex items-center gap-2">
            <CalendarDays className="text-slate-900 h-6 w-6" /> Calendário de Ocupação
          </h2>
          <p className="text-slate-400 text-xs">
            Visualização detalhada por morada e quarto das estadias Coolivin. As barras Gantt encurtam ou esticam automaticamente se houver uma Data de Saída Comunicada ativa.
          </p>
        </div>

        {/* BARRA DE CONTROLO DO CALENDÁRIO */}
        <div className="flex flex-wrap items-center gap-3">
          {/* BOTÃO IR PARA HOJE */}
          <button
            type="button"
            onClick={() => {
              const hoje = new Date();
              setCursorDate(hoje);
              setSelectedCalendarYear(hoje.getFullYear());
              setSelectedDetailMonth(hoje.getMonth());
            }}
            className="bg-slate-955 hover:bg-slate-900 text-white font-bold px-4 py-2 rounded-xl text-xs flex items-center gap-1.5 uppercase transition-all shadow-sm"
          >
            <RefreshCw className="h-3 w-3" /> Ir Para Hoje
          </button>

          {/* BOTÕES DO CURSOR HORIZONTAL */}
          <div className="flex items-center gap-1 bg-slate-100 p-1.5 rounded-xl border border-slate-200 text-[10px] text-slate-500 font-bold">
            <span className="uppercase px-1">Cursor:</span>
            <button
              type="button"
              onClick={() => {
                setCursorDate((prev) => {
                  const d = new Date(prev);
                  if (calendarViewMode === "anual") {
                    d.setMonth(d.getMonth() - 1);
                  } else {
                    d.setDate(d.getDate() - 1);
                  }
                  setSelectedCalendarYear(d.getFullYear());
                  setSelectedDetailMonth(d.getMonth());
                  return d;
                });
              }}
              className="p-1 bg-white border border-slate-200 rounded-lg shadow-sm font-bold text-slate-700 hover:bg-slate-50"
            >
              ◀
            </button>
            <button
              type="button"
              onClick={() => {
                setCursorDate((prev) => {
                  const d = new Date(prev);
                  if (calendarViewMode === "anual") {
                    d.setMonth(d.getMonth() + 1);
                  } else {
                    d.setDate(d.getDate() + 1);
                  }
                  setSelectedCalendarYear(d.getFullYear());
                  setSelectedDetailMonth(d.getMonth());
                  return d;
                });
              }}
              className="p-1 bg-white border border-slate-200 rounded-lg shadow-sm font-bold text-slate-700 hover:bg-slate-50"
            >
              ▶
            </button>
          </div>

          {/* SELETOR DE ZOOM UNIFICADO */}
          <div className="flex bg-slate-100 p-1 rounded-xl border border-slate-200">
            <button
              type="button"
              onClick={() => setCalendarViewMode("anual")}
              className={`px-3 py-1.5 rounded-lg text-[10px] font-black uppercase ${
                calendarViewMode === "anual" ? "bg-white text-slate-900 shadow-sm" : "text-slate-500"
              }`}
            >
              Anual (12M)
            </button>
            <button
              type="button"
              onClick={() => setCalendarViewMode("semanal")}
              className={`px-3 py-1.5 rounded-lg text-[10px] font-black uppercase ${
                calendarViewMode === "semanal" ? "bg-white text-slate-900 shadow-sm" : "text-slate-500"
              }`}
            >
              🔍 Zoom Semanal
            </button>
          </div>

          {/* VISUALIZADOR DE ANO DE REFERÊNCIA */}
          <div className="flex items-center gap-1 bg-slate-100 p-1.5 rounded-xl border border-slate-200">
            <button
              type="button"
              onClick={() => setSelectedCalendarYear((p) => p - 1)}
              className="p-1 bg-white border border-slate-200 rounded-lg shadow-sm font-bold text-slate-700"
            >
              ◀
            </button>
            <span className="text-xs font-black px-2 font-mono text-slate-900">
              {selectedCalendarYear}
            </span>
            <button
              type="button"
              onClick={() => setSelectedCalendarYear((p) => p + 1)}
              className="p-1 bg-white border border-slate-200 rounded-lg shadow-sm font-bold text-slate-700"
            >
              ▶
            </button>
          </div>
        </div>
      </div>

      {/* ÁREA DA MATRIZ GANTT */}
      <div className="bg-white rounded-3xl p-6 shadow-sm border border-slate-200 relative pt-12 overflow-visible">
        {/* CABEÇALHO HORIZONTAL DINÂMICO */}
        <div className="flex border-b border-slate-100 pb-3 mb-4 font-bold text-slate-400 text-[10px] uppercase tracking-wider relative z-10">
          <div className="w-1/4">Apartamento / Quarto</div>
          <div className="w-3/4">
            {calendarViewMode !== "semanal" ? (
              <div className="grid grid-cols-12 text-center font-black">
                {["JAN", "FEV", "MAR", "ABR", "MAI", "JUN", "JUL", "AGO", "SET", "OUT", "NOV", "DEZ"].map((m) => (
                  <div key={m}>{m}</div>
                ))}
              </div>
            ) : (
              <div className="grid grid-cols-7 text-center font-mono text-[10px] font-black text-indigo-600 bg-indigo-50/40 py-1.5 rounded-xl">
                {Array.from({ length: 7 }).map((_, i) => {
                  const diaAlvo = new Date(cursorDate || new Date());
                  diaAlvo.setDate(diaAlvo.getDate() + i);
                  return (
                    <div key={i}>
                      {diaAlvo.getDate()}{" "}
                      {diaAlvo.toLocaleString("pt-PT", { month: "short" }).toUpperCase()}
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        {/* LISTAGEM HORIZONTAL DAS ESTADIAS */}
        <div className="space-y-4 relative z-10">
          {PROPRIEDADES.map((prop) => {
            const rooms = propertyRoomsMatrix[prop] || {};
            const isCollapsed = collapsedProperties[prop];
            const roomNames = Object.keys(rooms);

            return (
              <div key={prop} className="border-b border-slate-100 pb-3 last:border-0 last:pb-0">
                <div
                  onClick={() => togglePropertyCollapse(prop)}
                  className="flex items-center justify-between cursor-pointer bg-slate-50 hover:bg-slate-100 p-2.5 rounded-xl border border-slate-200/60"
                >
                  <div className="flex items-center gap-2 text-slate-800">
                    <Building className="h-3.5 w-3.5 text-slate-400" />
                    <h4 className="font-extrabold text-slate-900 text-xs">{prop}</h4>
                  </div>
                  <span className="text-[10px] text-slate-400 font-bold uppercase">
                    {isCollapsed ? "Expandir ➔" : "Recolher ⬇"}
                  </span>
                </div>

                {!isCollapsed && (
                  <div className="space-y-3 mt-3 pl-4 animate-fadeIn">
                    {roomNames.map((roomName) => {
                      const roomStays = rooms[roomName] || [];
                      return (
                        <div key={roomName} className="flex items-center min-h-[40px]">
                          <div className="w-1/4 font-semibold text-slate-500 text-[11px] truncate pr-2">
                            {roomName}
                          </div>

                          <div className="w-3/4 relative h-8 bg-slate-50/60 rounded-xl border border-slate-200/60 shadow-inner overflow-visible">
                            {roomStays.map((stay) => {
                              const inDate = parseDateAgnostic(stay.checkIn);
                              const outDate = parseDateAgnostic(stay.checkOut);

                              let leftPercent = 0;
                              let widthPercent = 0;

                              if (calendarViewMode !== "semanal") {
                                const startYear = new Date(`${selectedCalendarYear}-01-01T00:00:00`);
                                const endYear = new Date(`${selectedCalendarYear}-12-31T23:59:59`);
                                if (inDate > endYear || outDate < startYear) return null;

                                const displayStart = Math.max(startYear.getTime(), inDate.getTime());
                                const displayEnd = Math.min(endYear.getTime(), outDate.getTime());
                                const totalYearMs = endYear.getTime() - startYear.getTime();

                                leftPercent = ((displayStart - startYear.getTime()) / totalYearMs) * 100;
                                widthPercent = ((displayEnd - displayStart) / totalYearMs) * 100;
                              } else {
                                const startWeek = new Date(cursorDate || new Date());
                                startWeek.setHours(0, 0, 0, 0);
                                const endWeek = new Date(startWeek);
                                endWeek.setDate(endWeek.getDate() + 7);
                                endWeek.setHours(23, 59, 59, 999);

                                if (inDate > endWeek || outDate < startWeek) return null;

                                const displayStart = Math.max(startWeek.getTime(), inDate.getTime());
                                const displayEnd = Math.min(endWeek.getTime(), outDate.getTime());
                                const totalWeekMs = endWeek.getTime() - startWeek.getTime();

                                leftPercent = ((displayStart - startWeek.getTime()) / totalWeekMs) * 100;
                                widthPercent = ((displayEnd - displayStart) / totalWeekMs) * 100;
                              }

                              let corGantt = "bg-blue-500 text-white";
                              let labelTag = "RESERVADO";

                              if (stay.status === "Ativo") {
                                corGantt = "bg-emerald-500 text-white";
                                labelTag = "ATIVO";
                              } else if (
                                stay.status === "Concluído" ||
                                (typeof obterStatusRealStay === "function" && obterStatusRealStay(stay) === "Concluído")
                              ) {
                                corGantt = "bg-slate-200 text-slate-700 border border-slate-300";
                                labelTag = "CONCLUÍDO";
                              }

                              return (
                                <div
                                  key={stay.id}
                                  onClick={() => focarInquilinoNaTimeline(stay.id)}
                                  style={{ left: `${leftPercent}%`, width: `${widthPercent}%` }}
                                  className={`absolute top-1 bottom-1 rounded-lg shadow-sm flex items-center justify-between px-3 cursor-pointer z-10 text-[10px] font-bold truncate ${corGantt}`}
                                >
                                  <span className="truncate pr-1">{stay.inquilino}</span>
                                  <span className="text-[7px] bg-white/20 px-1 py-0.5 rounded tracking-wide uppercase font-black flex-shrink-0">
                                    {labelTag}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {/* RENDERIZAÇÃO DA LINHA DE SINAL CORRIGIDA */}
        {(() => {
          let leftPercent = 50;
          let labelTexto = "";
          const dataGantt = cursorDate ? new Date(cursorDate) : new Date();

          if (calendarViewMode !== "semanal") {
            const startYear = new Date(`${selectedCalendarYear}-01-01T00:00:00`);
            const endYear = new Date(`${selectedCalendarYear}-12-31T23:59:59`);
            const totalMs = endYear.getTime() - startYear.getTime();
            dataGantt.setFullYear(selectedCalendarYear);
            const ratioAno = (dataGantt.getTime() - startYear.getTime()) / totalMs;

            leftPercent = 25 + ratioAno * 75;
            labelTexto = `SINAL: ${dataGantt.getDate()} ${dataGantt.toLocaleString("pt-PT", { month: "short" }).toUpperCase()}`;
          } else {
            leftPercent = 25;
            labelTexto = `FOCO: ${dataGantt.getDate()} ${dataGantt.toLocaleString("pt-PT", { month: "short" }).toUpperCase()}`;
          }

          leftPercent = Math.max(0, Math.min(100, leftPercent));

          return (
            <div
              style={{ left: `${leftPercent}%` }}
              className="absolute top-0 bottom-0 w-[2px] bg-rose-500 z-20 pointer-events-none transition-all duration-150"
            >
              <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-rose-500 text-white text-[8px] font-black px-1.5 py-0.5 rounded-md shadow whitespace-nowrap">
                {labelTexto}
              </div>
            </div>
          );
        })()}
      </div>
    </div>
  );
}
